import { getAddressString } from "./get-address-string";

export function getHasValidAddress(fields: Parameters<typeof getAddressString>[0]) {
	const addressString = getAddressString(fields, "--");
	return addressString !== "--";
}
